export default __webpack_public_path__ + "static/media/ai-treso.ce1ed3cc.png";